import React from 'react';
import { SeasonalHotspotsData } from '../../data/data-seasonal-hotspots';
import CountryFlag from '../common/countryFlag/country-flag';
// import ProgressBarSeasonal from '../common/progressBarSeasonal/progress-bar-seasonal';
import styles from  './seasonal-hotspots.module.scss'; 

// const highestPeakHolidayMonth = Math.max(...SeasonalHotspotsData.map(data => data.peakHolidayMonth));

const HotspotTableRow = (data) => {
    const { city, peakHolidayMonth, residents, country } = data;
    // const progressBarWidth = `${peakHolidayMonth/highestPeakHolidayMonth*100}%`;
    // const progressBarStyles = {
    //     width: progressBarWidth
    // };
  
    return (
      <tr>
        <td>
            {city} 
            <div className={`d-md-none ${styles.mobileCountryFlag}`}>
                <CountryFlag country={country} />
            </div>
        </td>
        
        <td className="text-center d-none d-md-table-cell">{residents}</td>
        <td className={`no-border-right d-md-none ${styles.progressContentCol}`}>
            {/* <div style={progressBarStyles}>
                <ProgressBarSeasonal residents={residents} peakHolidayMonthResidents={peakHolidayMonth} />
            </div> */}
            <div className={`${styles.mobileResidents} d-md-none`}>
                <div>
                    <div className={styles.label}>Residents</div>
                    {residents}
                </div>
                <div>
                    <div className={styles.label}>Peak holidy month</div>
                    {peakHolidayMonth}+
                </div>
            </div>
        </td>
        <td className="text-center d-none d-md-table-cell">{peakHolidayMonth}+</td>
        <td className="d-none d-md-table-cell text-center">
            <CountryFlag country={country} />
        </td>
      </tr>
    );
  }


const SeasonalHotspots = () =>{

    return( 
        <>
            <table className={`chartTable ${styles.hotspotsTable}`}>
                <thead>
                    <tr className="d-none d-md-table-row">
                        <th className="no-border-bottom pt-0"></th>
                        <th colSpan={2} className="no-border-bottom font-weight-600 text-center pt-0">Centi-millionaires (USD 100m+)</th>
                        <th className="no-border-bottom pt-0"></th>
                    </tr>
                    <tr className="d-none d-md-table-row">
                        <th className={styles.cityCol} width="25%">Seasonal cities and towns</th>
                        
                        <th className="text-center" width="25%">Residents</th>
                        <th className={`d-md-none ${styles.progressCol}`}></th>
                        <th className="text-center" width="25%">Peak holiday month</th>
                        <th className={`${styles.countryCol}`} width="25%">Country</th>
                    </tr>
                    <tr className="d-md-none">
                        <th>Seasonal cities and towns</th>
                        <th>Centi-millionaires (USD 100m+)</th>
                    </tr>
                </thead>
                <tbody>
                {SeasonalHotspotsData.sort((a, b)=>  
                     b.residents - a.residents
                ).map((hotspot, index) => (
                    <HotspotTableRow key={index} {...hotspot} />
                ))}
                </tbody>
            </table>

            <div className="footer-note mt-5">
                    <ul>
                      <li>Peak month differs from city to city over the course of 2022. Resident figures for 31 December 2022.</li>
                      <li>'Centi-millionaires' refers to individuals with investable wealth of USD 100 million or more.</li>
                      <li>Peak month figures include centi-millionaire residents and second home owners, but exclude those staying in hotels.</li>
                    </ul>
                    <p>Source: New World Wealth</p>
            </div>
        </>
    )
}

export default SeasonalHotspots;